import React, { useEffect, useRef, Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import image from '../../../../assets/img/svg/Image.svg';
import Ship from "../../../../assets/img/svg/Ship.svg";
import Close from "@material-ui/icons/Close"
import $ from 'jquery'
import moment from "moment"
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Autocomplete from "react-autocomplete";
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import styles from "../../../../assets/jss/customStyle";
import { geteditdwprdocinfo, filedeletedwpr, dwprlookupdescription } from "../../../../actions/DWPRAction";
import del from "../../../../assets/img/svg/Del.svg"
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import deactive from '../../../../assets/img/svg/deactive.svg';
import { getSettingsFormat } from "../../../../actions/SettingsAction"

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    inputfieldAlign: {
        "& fieldset": {
            top: "-1px !important",
        }

    }
}));

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class EditDWPR_Detail extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Docs: [],
            isMobile: false,
            isError: false,
            isView: false,
            filename: "",
            awsname: "",
            Id: 0,
            DelIndex: 0,
            Error: {
                "ActivityError": false,
                "StartDateError": false,
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",
                "Activity": "",
                "StartDate": ""
            },
            ViewDate: "",
            ViewData: [],
        }
    }

    componentDidMount() {
        window.location.pathname == '/dailyworkprogressreport/edit' ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.props.dispatch(getlookupdocinfo("DailyProgress"))
        this.props.dispatch({ type: "PASS_CANCEL", data: false })
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("DWPREditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.props.dispatch(getSettingsFormat(this.state.ProjectId))
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        if (window.location.pathname == "/dailyworkprogressreport/view") {
            this.state.ViewDate = localStorage.getItem("DWPRViewId")
            this.setState({})
            this.ViewPage(this.state.ViewDate);
        } else {
            this.geteditdwprdocinfo(this.state.addData.Id)
            this.props.dispatch(dwprlookupdescription())
        }
    }

    ViewPage = (id) => {
        let apiUrl = API.DWPR_LISTVIEW + '/id?id=' + id
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.ViewData = response.data;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, index) => {
            if (this.state.DelIndex == index) {
                if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                    this.props.dispatch(filedeletedwpr(this.state.addData.Id, this.state.awsname))
                }
            }
            if (this.state.DelIndex != index) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup1").modal("hide");
    }

    OpenPopup = (filename, awsname, id, index) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.state.DelIndex = index;
        this.setState({})
        window.$("#deletepopup1").modal("show");
    }
    openView = (url, name) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    geteditdwprdocinfo = (id) => {
        let apiUrl = API.DWPR_LISTVIEW + '/id?id=' + id;
      
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                  
                    this.props.dispatch({ type: "DWPREDIT_DOCS", data: response.data });
                    this.props.dispatch({ type: "ERROR_DWPRFILES", data: this.state.Error })
                    // this.props.dispatch({ type: "PASS_DWPROTHERS", data: this.state.others })
                    this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData })
                    this.props.dispatch({ type: "SHARE_DWPRDATAS", data: this.state.Docs })
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Description = response.data.Description;
                    this.state.addData.Activity = response.data?.Activity;
                    this.state.addData.StartDate = response.data?.StartDate;
                    if (response.data?.Photos.length > 0) {
                        response.data?.Photos.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.Docs = response.data?.Photos;
                    }
                    let Error = {
                        "ActivityError": false,

                        "StartDateError": false,
                    }
                    this.state.Error = Error;
                    // if (this.state.addData.Activity == 'others') {
                    //     this.state.others = true;
                    //     this.setState({});
                    // }
                    // else {
                    //     this.state.others = false;
                    //     this.setState({});
                    // }
                    this.setState({})
                    this.props.dispatch({ type: "ERROR_DWPRFILES", data: this.state.Error })
                    // this.props.dispatch({ type: "PASS_DWPROTHERS", data: this.state.others })
                    this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData })
                    this.props.dispatch({ type: "SHARE_DWPRDATAS", data: this.state.Docs })
                } else {
                   
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        this.props.dispatch({ type: "PASS_CANCEL", data: false })
    }

    handleInputChange = (e, str) => {
        this.props.dispatch({ type: "PASS_CANCEL", data: true })
      
        if (str == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else if (str == "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[str] = e.target.value;
            this.setState({});
        }
        this.setState({})
        this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData })
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    UploadFile = (e) => {
        this.props.dispatch({ type: "PASS_CANCEL", data: true })
      
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
                FileUrl: await this.toBase64(a),
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
        this.props.dispatch({ type: "SHARE_DWPRDATAS", data: this.state.Docs })
    };

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    setCheckbox = (index) => {
        this.state.Docs.map((i, ind) => {
            if (ind == index) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e) => {
        this.props.dispatch({ type: "PASS_CANCEL", data: true })
        this.state.addData.Activity = e.target.value;
        this.setState({});
        // if (this.state.addData.Activity == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
        // this.props.dispatch({ type: "PASS_DWPROTHERS", data: this.state.others })
        this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData })
    };

    handleProjectNameSelectChange = (e) => {
        this.props.dispatch({ type: "PASS_CANCEL", data: true })
        this.state.addData.Activity = e;
        this.setState({});
        // if (this.state.addData.Activity == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
        // this.props.dispatch({ type: "PASS_DWPROTHERS", data: this.state.others })
        this.props.dispatch({ type: "SHARE_DWPRFILES", data: this.state.addData })
    };

    Image = (url) => {
        // <img src={url} id="deletepopup1"/>
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                <div className="row px-1 mt-n3">

                    {this.state.isView ?
                        <>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex"}>Date :
                                    </label>                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    <TextField
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        id="type-date"
                                        disabled
                                        value={this.state.ViewData.StartDate && moment(this.state.ViewData.StartDate).format("yyyy-MM-DD")}
                                        placeholder={this.state.ViewData.StartDate && moment(this.state.ViewData.StartDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                        InputProps={{
                                            className: `border-radius view-color ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex"}>Activities&nbsp;:
                                    </label>                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    <TextField
                                        type="text"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        style={{ backgroundColor: "#F8F8F8" }}
                                        value={this.state.ViewData.Activity}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />

                                </div>
                            </div>
                            {this.state.ViewData.Description &&
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "float-end"} >Description&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 pb-4  col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                        <TextField
                                            multiline
                                            rows={4}
                                            variant="outlined"
                                            size="small"
                                            disabled
                                            style={{ backgroundColor: "#F8F8F8" }}
                                            fullWidth
                                            value={this.state.ViewData.Description}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    </div>
                                </div>}
                            {this.state.ViewData.Photos && this.state.ViewData.Photos.length > 0 &&
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : " col-md-2"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "mt-2 float-end"}>Photos&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pt-3 col-md-2"}`}>

                                        <div className="row px-1">
                                            {this.state.ViewData.Photos && this.state.ViewData.Photos.map((i) => (
                                                <div className={`col-6 col-sm-4 col-lg-3 col-xl-2 align-items-center  px-1 mt-1 mb-2 ${window.innerWidth < 410 ? "col-12" : this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName) }}>
                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="col-10 col-sm-10 col-lg-10 col-xl-10 col-md-10">
                                                            <div className="cursorPointer pt-2 ml-3 overflow" onClick={() => { this.openView(i.FileUrl, i.FileName) }}>{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                    </div>

                                </div>}
                            {/* {this.state.ViewData.Photos && this.state.ViewData.Photos.length > 0 &&
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : " mt-2 col-md-2"}`}>
                                        <label className={this.state.isMobile ? "mt-2" : "float-end"}>Photos&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12  col-md-10 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom" : "pt-3 col-md-2"}`}>
                                        <div className="row px-1">
                                            {this.state.ViewData.Photos && this.state.ViewData.Photos.map((i) => (
                                                <div className={`col-10 col-sm-4 col-lg-3 col-xl-2 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-6"}`}>
                                                    <div className="row d-flex">
                                                        <div className="cursorPointer col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName) }}>
                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="cursorPointer col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 ">
                                                            <label className="cursorPointer fw-700 pt-2 ml-3 word-break" onClick={() => { this.openView(i.FileUrl, i.FileName) }}>{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>} */}

                        </>
                        :
                        <>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex"}>Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    {this.props.errordwprpass.StartDateError ?
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.StartDate && moment(this.state.addData.StartDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.StartDate && moment(this.state.addData.StartDate).format(this.props.settings.Convention  ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "StartDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${localStorage.getItem('ProjectStatus').toLowerCase() == 'completed' ? localStorage.getItem('ProjectCompletionDate') : localStorage.getItem('ExtensionDate') != null ? localStorage.getItem('ExtensionDate') : localStorage.getItem('EstimatedCompletionDate')}`,
                                                min: `${localStorage.getItem('ProjectStartDate')}`,
                                              }}
                                        />
                                        :
                                        <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            id="type-date"
                                            value={this.state.addData.StartDate && moment(this.state.addData.StartDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.StartDate && moment(this.state.addData.StartDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                            onChange={(e) => { this.handleInputChange(e, "StartDate") }}
                                            fullWidth
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            inputProps={{
                                                max: `${localStorage.getItem('ProjectStatus').toLowerCase() == 'completed' ? localStorage.getItem('ProjectCompletionDate') : localStorage.getItem('ExtensionDate') != null ? localStorage.getItem('ExtensionDate') : localStorage.getItem('EstimatedCompletionDate')}`,
                                                min: `${localStorage.getItem('ProjectStartDate')}`,
                                              }}
                                        />
                                    }

                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex"}>Activities&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    <div className="autocomplete-wrappers">
                                        {this.props.errordwprpass.ActivityError ? <>
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Activity}
                                                inputProps={{
                                                    placeholder: "Activitiy",
                                                }}
                                                items={this.props.DWPRDESC_LOOKUP ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            fullWidth
                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />
                                        </>
                                            :
                                            <Autocomplete
                                                contentEditable={true}
                                                value={this.state.addData.Activity}
                                                inputProps={{
                                                    placeholder: "Activity",
                                                }}
                                                items={this.props.DWPRDESC_LOOKUP ?? []}
                                                getItemValue={(item) => item.Name}
                                                shouldItemRender={this.renderProjectNames.bind(this)}
                                                renderMenu={(item) => (
                                                    <div className="dropdowns d-block" >{item}</div>
                                                )}
                                                renderInput={(props) => {
                                                    return (
                                                        <input
                                                            className="form-control border-radius"
                                                            id="exampleFormControlInput1"
                                                            {...props}
                                                            // fullWidth
                                                            style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                        // style={{ width: this.state.isMobile ? 100 : 223, height: 32, fontSize: 12, color: "#000000" }}
                                                        />
                                                    );
                                                }}
                                                renderItem={(item, isHighlighted) => (
                                                    <div
                                                        className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                            }`}
                                                    >
                                                        {item.Name}
                                                    </div>
                                                )}
                                                onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                            />}

                                    </div>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end"} >Description&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    <TextField
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Description}
                                        onChange={(e) => this.handleInputChange(e, "Description")}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>

                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end"}>Photos&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1" : "col-md-4 pt-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile(e)}
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile(e)}
                                        ref={this.inputFile}
                                    />
                                </div>
                                {/* <div className="col-12 col-sm-12  col-md-12 col-lg-8 col-xl-8 pt-2 align-items-center">
                                    <div className="row px-1">
                                        {this.state.Docs && this.state.Docs.map((m, i) => (
                                            <div className={this.state.isMobile ? "col-12 col-sm-6 col-lg-4 col-xl-3 col-md-6 align-items-center border-right grid-container" : "col-6 col-sm-6 col-lg-4 col-xl-3 col-md-6 align-items-center border-right px-1 grid-container"} >
                                                <div className="row grid-container">
                                                    <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 mt-2" onClick={() => this.Image(i.FileUrl)}>
                                                        <img src={m.FileUrl} style={{ width: "31px", height: "31px" }} />
                                                    </div>
                                                    <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8 ml-1">
                                                        <label className="fw-700 pt-1 word-break">{m.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(m.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                    </div>
                                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 px-1 mt-2 pt-1">
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(m.FileName, m.AwsUniqueFileName, m.Id, i) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div> */}
                                <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className="row px-1">
                                        {this.state.Docs && this.state.Docs.map((i, ind) => {
                                            return (
                                                <div className={`col-10 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-12"}`}>
                                                    <div className="row d-flex">
                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName) }}>
                                                            <img src={i.FileUrl} className="cursorPointer" onClick={() => { this.openView(i.FileUrl, i.FileName) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8 ">
                                                            <label onClick={() => { this.openView(i.FileUrl, i.FileName) }} className="cursorPointer fw-700 pt-2 ml-3 word-break">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                        </div>
                                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 px-1 mt-2 pt-2">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id, ind) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-n4 col-md-2"}`}>
                                    <label className={this.state.isMobile ? "mt-2" : "float-end"}>Comments&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 pb-4  col-lg-10 col-xl-11   ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                    <TextField
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Comments}
                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                    <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                </div>
                            </div>
                        </>}

                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : this.props.menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" onClick={() => { window.$("#deletepopup1").modal("hide") }} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade" id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll' }}>
                    <div class="modal-dialog modal-md" role="document">
                        <div className="modal-dialog">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content"}>
                                <div class="modal-body pb-0">
                                    <div className="row">
                                        <div className="col-12 text-right">
                                            <img className='cursorPointer ' src={deactive} onClick={() => { window.$('#viewscreen').modal('hide') }} style={{ width: '24px', height: '24px' }} />
                                        </div>
                                        <div className='col-12 text-center'>
                                            <img src={this.state.fileUrl} className="img-fluid" style={{ width: '450px', height: '450px' }}></img>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <label className='f-size-12  mt-2'>{this.state.fileName}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        DWPRDESC_LOOKUP: state.MasterDataReducer.Lookup_data || [],
        geteditdwpr: state.DWPRReducer.geteditdwpr || [],
        errordwprpass: state.DWPRReducer.errordwprpass || [],
        shareddwprfile: state.DWPRReducer.shareddwprfile || [],
        shareddwprdata: state.DWPRReducer.shareddwprdata || [],
        settings: state.commonReducer.settings || [],
    };
}

EditDWPR_Detail.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDWPR_Detail))
);
